
interface IntegrationsHeroProps {
  searchQuery: string;
  onSearchChange: (query: string) => void;
}

export default function IntegrationsHero({ searchQuery, onSearchChange }: IntegrationsHeroProps) {
  return (
    <section className="pt-32 pb-16 bg-gradient-to-br from-[#e4f4ff]/20 via-white to-[#b3d9ff]/10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <div className="inline-flex items-center px-4 py-2 bg-[#e4f4ff]/30 rounded-full text-[#22577A] font-medium mb-6">
            <i className="ri-plug-line mr-2"></i>
            50+ Integrations & Growing
          </div>

          <h1 className="text-5xl lg:text-6xl font-bold text-[#22577A] mb-6">
            Connect Everything
            <span className="block text-[#38a3a5]">You Already Use</span>
          </h1>

          <p className="text-xl text-gray-700 mb-12 max-w-3xl mx-auto">
            Seamlessly integrate AgenticAI with your favorite tools. Our AI enhances every integration to make your workflow smarter and more efficient.
          </p>

          {/* Search Bar */}
          <div className="max-w-2xl mx-auto">
            <div className="relative">
              <i className="ri-search-line absolute left-6 top-1/2 transform -translate-y-1/2 text-2xl text-gray-400"></i>
              <input
                type="text"
                placeholder="Search integrations..."
                value={searchQuery}
                onChange={(e) => onSearchChange(e.target.value)}
                className="w-full pl-16 pr-6 py-5 text-lg border-2 border-gray-200 rounded-xl focus:border-[#66b3ff] focus:outline-none transition-colors"
              />
            </div>
          </div>
        </div>

        {/* Stats */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 max-w-4xl mx-auto">
          <div className="text-center">
            <div className="text-4xl font-bold text-[#22577A] mb-2">50+</div>
            <p className="text-gray-600">Integrations</p>
          </div>
          <div className="text-center">
            <div className="text-4xl font-bold text-[#22577A] mb-2">12</div>
            <p className="text-gray-600">Social Platforms</p>
          </div>
          <div className="text-center">
            <div className="text-4xl font-bold text-[#22577A] mb-2">5,000+</div>
            <p className="text-gray-600">Via Zapier</p>
          </div>
          <div className="text-center">
            <div className="text-4xl font-bold text-[#22577A] mb-2">
              <i className="ri-ai-generate"></i>
            </div>
            <p className="text-gray-600">AI Enhanced</p>
          </div>
        </div>
      </div>
    </section>
  );
}
